import { render, staticRenderFns } from "./InviteAccepted.vue?vue&type=template&id=1cda7f82&scoped=true"
import script from "./InviteAccepted.vue?vue&type=script&lang=js"
export * from "./InviteAccepted.vue?vue&type=script&lang=js"
import style0 from "./InviteAccepted.vue?vue&type=style&index=0&id=1cda7f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda7f82",
  null
  
)

export default component.exports